import { getApiUrl } from '../config/api.config';

export const EVENT_TYPE_CTA = 'cta_click';
export const EVENT_TYPE_PAGE = 'page_visit';
export const EVENT_TYPE_FORM_STEP = 'form_step';
export const EVENT_TYPE_FORM_COMPLETE = 'form_complete';

// Generate or retrieve a session ID for tracking users anonymously
const getSessionId = () => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = `s-${Date.now()}-${Math.random().toString(36)}`;
        localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
};

// Function to send tracking data
export const trackEvent = async (eventType, elementId = null) => {
    const payload = {
        sessionId: getSessionId(),
        userId: localStorage.getItem('userId'),
        pageUrl: window.location.href,
        eventType: eventType,
        elementId: elementId,
      };

    // Skip tracking if on localhost
    if (window.location.href.includes('localhost')) {
        return;
    }

    // console.log(payload);
    try {
        await fetch(`${getApiUrl()}/application`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error tracking event:', error);
    }
};

// GA4 tracking functions
export const trackGA4Event = (eventName, parameters = {}) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, parameters);
    } else {
        console.error(`GA4 Error: Failed to track event "${eventName}" - gtag not available`);
        
        // Try to queue the event for later
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                'event': eventName,
                ...parameters
            });
        }
    }
};

// Form-specific tracking functions
export const trackFormStep = (stepNumber, stepName, formData = null) => {
    // Track in your existing system
    trackEvent(EVENT_TYPE_FORM_STEP, `step_${stepNumber}_${stepName}`);
    
    // Track in GA4
    trackGA4Event('form_step', {
        step_number: stepNumber,
        step_name: stepName,
        form_type: 'loan_application'
    });
    
    // Track conversion events
    if (stepNumber === 1) {
        trackGA4Event('loan_application_started', {
            step_number: stepNumber,
            step_name: stepName
        });
    }
};

export const trackFormCompletion = (formData = null) => {
    // Track in your existing system
    trackEvent(EVENT_TYPE_FORM_COMPLETE, 'loan_application');
    
    // Track in GA4
    trackGA4Event('loan_application_completed', {
        form_type: 'loan_application',
        loan_amount: formData?.loanAmount || 'unknown',
        loan_purpose: formData?.loanPurpose || 'unknown'
    });
};
